import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DashboardLayout from "../../layouts/DashboardLayout";
import {
  ORDERS_DETAILS_URL,
  ORDERS_INVOICE_SENT_URL,
  ORDERS_STATUS_UPDATE_URL,
  PRODUCT_IMAGE_URL,
} from "../../utils/Constant";
import { formatDate, amountToWords, convertIsoToCustomFormat } from "../../utils/Helper";
import axios from "axios";
const OrderDetails = () => {
  const [OrderDetails, setOrderDetails] = useState([]);
  const [selectOrderStatus, setSelectOrderStatus] = useState([]);
  const navigate = useNavigate();
  const { orderId } = useParams();
  //console.log("orderId", orderId);
  const authToken = useSelector((state) => state.token);
  //console.log(authToken);

  const fetchDetails = async () => {
    try {
      if (orderId) {
        showToast(true, "Data Loading. Please wait..", "info");
      }
      const response = await fetch(`${ORDERS_DETAILS_URL}/${orderId}`, {
        headers: {
          Authorization: `Bearer ${authToken.token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setOrderDetails(data);
      setSelectOrderStatus(data.orderStatus);
    } catch (error) {
      console.error("Error fetching product:", error);
    }
  };
  useEffect(() => {
    if (authToken) {
      fetchDetails();
    } else {
      navigate("/login");
    }
  }, [orderId]);
  //console.log(OrderDetails);
  //console.log("OrderDetails", OrderDetails);

  const showToast = (loading, message, type, errors) => {
    let errorMessage = "";

    if (errors && errors.length > 0) {
      errorMessage = (
        <ul>
          {errors.map((error, index) => (
            <li key={index}>{error.msg}</li>
          ))}
        </ul>
      );
    }
    toast[type](
      <div>
        {loading} {message} {errorMessage}
      </div>,
      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000, // milliseconds
      }
    );
  };

  const [pickupBusy, setPickupBusy] = useState(false);
  const [pickupError, setPickupError] = useState("");
  const handlePickup = async action => {
    if (action === "relist" && !window.confirm("Confirm no pickup was arranged within 72 hours. Relist the item and record the platform fee as forfeited?")) return;
    setPickupBusy(true); setPickupError("");
    try {
      const response = await fetch(`${ORDERS_DETAILS_URL}/${orderId}/pickup`, {
        method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${authToken.token}` }, body: JSON.stringify({ action })
      });
      const data = await response.json();
      if (!response.ok) throw Error(data.error || "Unable to update pickup.");
      await fetchDetails();
    } catch (error) { setPickupError(error.message); }
    finally { setPickupBusy(false); }
  };
  const handlePrint = () => {
    window.print();
  };

  const currentDate = new Date();
  // Format the date as MM/DD/YYYY
  const formattedDate = `${
    currentDate.getMonth() + 1
  }/${currentDate.getDate()}/${currentDate.getFullYear()}`;

  //console.log("process.env.PUBLIC_URL", process.env.PUBLIC_URL);

  // Assume OrderDetails is an object with properties including orderStatus
  const orderStatus = OrderDetails?.orderStatus || ""; // Ensure a default value if orderStatus is undefined

  // Map order status to badge color
  const badgeColors = {
    pending_payment: "badge-warning",
    processing: "badge-info",
    on_hold: "badge-secondary",
    completed: "badge-success",
    cancelled: "badge-danger",
    refunded: "badge-dark",
    failed: "badge-danger",
    shipped: "badge-primary",
    delivered: "badge-success",
  };
  // Set default badge color if not found in the map
  const badgeColor = badgeColors[orderStatus] || "badge-primary";

  // Map PayPal response status to badge color
  const paypalBadgeColors = {
    COMPLETED: "badge-success",
    CREATED: "badge-info",
    DENIED: "badge-danger",
    EXPIRED: "badge-warning",
    FAILED: "badge-danger",
    "IN-PROGRESS": "badge-info",
    PARTIALLY_REFUNDED: "badge-dark",
    PENDING: "badge-warning",
    REFUNDED: "badge-dark",
    REVERSED: "badge-danger",
    VOIDED: "badge-secondary",
  };

  // Set default badge color if not found in the map
  const paymentStatus = (OrderDetails?.paymentStatus || "").toUpperCase(); // Replace with your actual PayPal status
  const paypalBadgeColor = paypalBadgeColors[paymentStatus] || "badge-primary";

  const totatBillAmount = OrderDetails?.totalAmount;

  const handleStatusChange = (event) => {
    setSelectOrderStatus(event.target.value);
    //console.log(selectOrderStatus);
  };

  const handleOrderStatusSubmit = async (e) => {
    //console.log("Handling order status submission...");
    e.preventDefault();
    if (authToken) {
      try {
        // Prepare the data to be sent in the API request
        const requestData = {
          orderStatus: selectOrderStatus,
        };

        // Make an API request to update the status
        const response = await axios.put(
          `${ORDERS_STATUS_UPDATE_URL}/${orderId}`,
          //'https://13.53.132.18:5000/admin/orders/status/update/65bcd02fb062199f5aedcb67',
          requestData,
          {
            headers: {
              Authorization: `Bearer ${authToken.token}`,
              // Add other headers if required
            },
          }
        );

        if (response) {
          showToast(true, response.data.message, "success");
          fetchDetails();
        }
        // Handle the success response, if needed
        //console.log("Status updated successfully", response.data);
      } catch (error) {
        // Handle the error response, if needed
        // console.error('Error sending invoice:', error.response || error);
        console.error("Error updating status:", error);
      }
    }
  };

  const handleSendInvoice = async (e) => {
    //console.log("invoice");
    e.preventDefault();
    if (authToken) {
      try {
        const requestData = {
          buyerEmail: OrderDetails.customerId.email,
          invoiceId: OrderDetails.invoiceId,
          orderDetails: {
            productName: OrderDetails.productId.productName,
            price: OrderDetails.orderAmount,
          },
        };
        //console.log(requestData);

        // Make an API request to send the invoice
        const response = await axios.post(
          `${ORDERS_INVOICE_SENT_URL}/${orderId}`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${authToken.token}`,
              // Add other headers if required
            },
          }
        );
        if (response) {
          showToast(true, response.data.message, "success");
        }

        // Handle the success response, if needed
        //console.log("Invoice sent successfully", response.data);
      } catch (error) {
        // Handle the error response, if needed
        console.error("Error sending invoice:", error);
      }
    }
  };

  return (
    <DashboardLayout>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Order Details</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Order Details</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                {OrderDetails?.buyNowCheckoutId && <div className="card p-3">
                  <h3>Buy It Now pickup</h3>
                  <p>Arrange by: {convertIsoToCustomFormat(OrderDetails.pickupArrangeBy)}</p>
                  <p>{OrderDetails.feeForfeitedAt ? "Fee forfeited; item relisted." : OrderDetails.pickupCompletedAt ? "Collected." : OrderDetails.pickupArrangedAt ? "Pickup arranged." : "Awaiting pickup arrangements."}</p>
                  {!OrderDetails.feeForfeitedAt && !OrderDetails.pickupCompletedAt && <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                    <button disabled={pickupBusy} onClick={() => handlePickup("arranged")}>Mark pickup arranged</button>
                    <button disabled={pickupBusy} onClick={() => handlePickup("collected")}>Mark collected</button>
                    {!OrderDetails.pickupArrangedAt && new Date(OrderDetails.pickupArrangeBy) <= new Date() && <button disabled={pickupBusy} onClick={() => handlePickup("relist")}>No arrangement — forfeit fee and relist</button>}
                  </div>}
                  {pickupError && <p role="alert">{pickupError}</p>}
                </div>}
                <div className="invoice p-3 mb-3">
                  <div className="row">
                    <div className="col-12">
                      <h4>
                        <i className="fas fa-globe" /> Mototrad.
                        <span className="float-right">
                          Invoice Date: {convertIsoToCustomFormat(OrderDetails?.orderTime)}
                        </span>
                        <br />
                        <span className="float-right">
                          Invoice No. : MTD-{OrderDetails?.invoiceId}
                        </span>
                      </h4>
                    </div>
                  </div>
                  <div
                    className="row invoice-info"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="col-sm-3 invoice-col">
                      <h5>Payment Details : </h5>
                      <br />
                      <br />
                      <b>Transaction ID:</b> {OrderDetails?.transactionId}
                      <br />
                      <br />
                      <b>Payment Date:</b> {convertIsoToCustomFormat(OrderDetails?.orderTime)}
                      <br />
                      <br />
                      <b>Payment Method:</b>{" "}
                      {OrderDetails?.paymentMethod == "paypal"
                        ? "Paypal"
                        : OrderDetails?.paymentMethod}
                      <br />
                      <br />
                      <b>
                        Payment Status:{" "}
                        <span className={`badge ${paypalBadgeColor}`}>
                          {paymentStatus.toLowerCase().charAt(0).toUpperCase() +
                            paymentStatus
                              .toLowerCase()
                              .slice(1)
                              .replace("_", " ")}
                        </span>
                      </b>
                    </div>
                    <div className="col-sm-3 invoice-col">
                      <h5>Order Details :</h5>
                      <br />
                      <br />
                      <b>Order No. : #{OrderDetails?.orderId}</b>
                      <br />
                      <br />
                      <b>Order Date:</b> {convertIsoToCustomFormat(OrderDetails?.orderTime)}
                      <br />
                      <br />
                      <b>
                        Order Status:{" "}
                        <span className={`badge ${badgeColor}`}>
                          {orderStatus.charAt(0).toUpperCase() +
                            orderStatus.slice(1).replace("_", " ")}
                        </span>
                      </b>
                      <br />
                      <br />
                    </div>
                    <div className="col-sm-3 invoice-col">
                      <h5>
                        Sold By :<br />
                      </h5>
                      <br />
                      <address>
                        <strong>Mototrad</strong>
                        <br />
                        795 Folsom Ave, Suite 600
                        <br />
                        San Francisco, CA 94107
                        <br />
                        <br />
                        <b>Phone:</b> (804) 123-5432
                        <br />
                        <b>Email:</b> info@mototrad.com
                      </address>
                    </div>
                    <div className="col-sm-3 invoice-col">
                      <h5>
                        {" "}
                        Customer Details :<br />
                      </h5>
                      <br />
                      <address>
                        <strong>
                          {OrderDetails?.customerId?.firstName}{" "}
                          {OrderDetails?.customerId?.lastName}
                        </strong>
                        <br />
                        {OrderDetails?.customerId?.address}
                        <br />
                        <br />
                        <b>Phone: </b>
                        {OrderDetails?.customerId?.phone}
                        <br />
                        <b>Email:</b>
                        {OrderDetails?.customerId?.email}
                      </address>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 table-responsive">
                      <table className="table table-striped" border={1}>
                        <thead>
                          <tr>
                            <th>Image</th>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Subtotal</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <img
                                style={{ height: "60px" }}
                                alt=""
                                className="table-avatar"
                                src={`${PRODUCT_IMAGE_URL}/${OrderDetails?.productId?.featuredImage}`}
                              />
                            </td>
                            <td>
                              <h6>{OrderDetails?.productId?.productName}</h6>
                            </td>
                            <td>
                              <h6>1</h6>
                            </td>
                            <td>
                              <h6>${OrderDetails?.productId?.buyNowPrice}</h6>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-3">
                      <form action="">
                        <div className="form-group">
                          <label htmlFor="productStatus">Product Status</label>
                          <select
                            className="form-control custom-select"
                            name="productStatus"
                            value={selectOrderStatus}
                            onChange={handleStatusChange}
                          >
                            <option value="pending_payment">
                              Pending Payment
                            </option>
                            <option value="processing">Processing</option>
                            <option value="on_hold">On Hold</option>
                            <option value="completed">Completed</option>
                            <option value="cancelled">Cancelled</option>
                            <option value="refunded">Refunded</option>
                            <option value="delivered">Delivered</option>
                          </select>
                          <br />
                          <button
                            type="submit"
                            class="btn btn-primary"
                            onClick={handleOrderStatusSubmit}
                          >
                            Change Order Status
                          </button>
                        </div>
                      </form>
                    </div>
                    <div class="col-5"></div>
                    <div className="col-4">
                      <div className="table-responsive">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th style={{ width: "50%" }}>Subtotal:</th>
                              <td>${OrderDetails?.productId?.buyNowPrice}</td>
                            </tr>
                            <tr>
                              <th>
                              Mototrad Commission (
                                {OrderDetails?.productId?.premiumType === "flat"
                                  ? "Flat" +
                                    OrderDetails?.productId?.premiumAmount
                                  : OrderDetails?.productId?.premiumAmount +
                                    "%"}
                                )
                              </th>
                              <td>${OrderDetails?.premiumAmount}</td>
                            </tr>

                            <tr>
                              <th>
                                <h5>Total:</h5>
                              </th>
                              <td>
                                <h5>${totatBillAmount} </h5>(
                                {amountToWords(totatBillAmount)})
                              </td>
                            </tr>

                            {OrderDetails?.orderType === "partial" ? (
                              <>
                                <tr>
                                  <th><span className="green">Paid Amount:</span></th>
                                  <td><span className="green">${OrderDetails?.paidAmount}</span></td>
                                </tr>
                                <tr>
                                  <th>
                                    <h5 className="red">Balance Amount:</h5>
                                  </th>
                                  <td>
                                    <h5 className="red">
                                      ${OrderDetails?.pendingAmount}
                                    </h5>
                                    <span  className="red">
                                      (
                                      {amountToWords(
                                        OrderDetails?.pendingAmount
                                      )}
                                      )
                                    </span>
                                  </td>
                                </tr>
                              </>
                            ) : (
                              <>
                                <tr>
                                  <th>
                                    <h5 className="green">Paid Amount:</h5>
                                  </th>
                                  <td>
                                    <h5 className="green">
                                      ${OrderDetails?.paidAmount}
                                    </h5>
                                    <span  className="green">
                                      ({amountToWords(OrderDetails?.paidAmount)}
                                      )
                                    </span>
                                  </td>
                                </tr>
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="row no-print">
                    <div className="col-12">
                      {/* <a
                        rel="noopener"
                        target="_blank"
                        className="btn btn-default"
                        onClick={handlePrint}
                      >
                        <i className="fas fa-print" /> Print
                      </a> */}

                      {/* <button
                        type="button"
                        className="btn btn-success float-right"
                      >
                        <i className="far fa-credit-card" /> Submit Payment
                      </button> */}
                      <button
                        rel="noopener"
                        target="_blank"
                        className="btn btn-info"
                        onClick={handlePrint}
                      >
                        <i className="fas fa-print" /> Print
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary float-right"
                        style={{ marginRight: "5px" }}
                        onClick={handleSendInvoice}
                      >
                        <i className="fas fa-download" /> Send Invoice
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </DashboardLayout>
  );
};

export default OrderDetails;

